import React from 'react'
import {
  AppBar,
  Button,
  Drawer,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Toolbar,
  Typography,
  useTheme,
  Box,
} from '@material-ui/core'

import { Link } from 'react-router-dom'

import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import Fingerprint from '@material-ui/icons/Fingerprint'
import { useTranslation } from 'react-i18next';
import ProgressBar from '../../UI/ProgressBar/progress-bar';
import { useSelector } from 'react-redux';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  closeMenuButton: {
    marginRight: 'auto',
    marginLeft: 0,
  },
  icons: {
    marginRight: theme.spacing(1),
  },
  logo: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    flexGrow: 1,
  },
  navButton: {
    marginLeft: theme.spacing(1),
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  listItem: {
    borderRadius: '0 24px 24px 0',
    marginRight: theme.spacing(1),
  },
}));

const HomeNavbar = () => {
  const classes = useStyles();
  const loading = useSelector(state => state.request.loading);
  const theme = useTheme();
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen)
  }

  const drawer = (
    <div>
      <div className={classes.drawerHeader}>
        <IconButton onClick={handleDrawerToggle} className={classes.closeMenuButton}>
          <CloseIcon />
        </IconButton>
      </div>
      <List>
        <ListItem 
          button 
          component={Link} 
          to="/" 
          onClick={handleDrawerToggle}
          className={classes.listItem}
        >
          <ListItemIcon>
            <Fingerprint />
          </ListItemIcon>
          <ListItemText primary={t('navbar.login')} />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar} elevation={1}>
        {loading ? <ProgressBar /> : null}
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.logo} noWrap>
            {t('app_name')}
          </Typography>
          <Hidden smDown>
            <Box display="flex" alignItems="center">
              <Button 
                component={Link} 
                to="/" 
                color="primary"
                variant="outlined"
                className={classes.navButton}
                startIcon={<Fingerprint />}
              >
                {t('navbar.login')}
              </Button>
            </Box>
          </Hidden>
        </Toolbar>
      </AppBar>

      <nav className={classes.drawer}>
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    </div>
  )
};

export default HomeNavbar;
